<template>
  <div class="dashboard-container">
    <div v-if="!alert" class="dashboard-content">
      <div class="highlight-cards">
        <div class="highlight-card contracts" @click="navigateToContratos">
          <div class="card-icon">
            <font-awesome-icon :icon="['fas', 'file-contract']" />
          </div>
          <div class="card-content">
            <h3>CONTRATOS</h3>
            <div class="card-stats">
              <span class="stats-number">{{ contracts.length }}</span>
              <span class="stats-label">Ativos</span>
            </div>
          </div>
          <div class="card-arrow">
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </div>
        </div>

        <div class="highlight-card orders" @click="navigateToPedidos">
          <div class="card-icon">
            <font-awesome-icon :icon="['fas', 'shopping-cart']" />
          </div>
          <div class="card-content">
            <h3>PEDIDOS</h3>
            <div class="card-stats">
              <span class="stats-number">{{ last_month_amount }}</span>
              <span class="stats-label">Este mês</span>
              <span class="trend-badge" :class="{'positive': !lastMonthPercentAmmount.includes('-')}">
                {{ lastMonthPercentAmmount }}
                <font-awesome-icon :icon="['fas', lastMonthPercentAmmount.includes('-') ? 'arrow-down' : 'arrow-up']" />
              </span>
            </div>
          </div>
          <div class="card-arrow">
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </div>
        </div>

        <div class="highlight-card financial" @click="navigateToFinanceiro">
          <div class="card-icon">
            <font-awesome-icon :icon="['fas', 'coins']" />
          </div>
          <div class="card-content">
            <h3>FINANCEIRO</h3>
            <div class="card-stats">
              <span class="stats-number">{{ getLastMonthValueBR }}</span>
              <span class="stats-label">em atraso</span>
              <span class="trend-badge" :class="{'positive': !lastMonthPercentValue.includes('-')}">
                {{ lastMonthPercentValue }}
                <font-awesome-icon :icon="['fas', lastMonthPercentValue.includes('-') ? 'arrow-down' : 'arrow-up']" />
              </span>
            </div>
          </div>
          <div class="card-arrow">
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </div>
        </div>

        <div class="highlight-card deliveries" @click="navigateToEntregas">
          <div class="card-icon">
            <font-awesome-icon :icon="['fas', 'truck']" />
          </div>
          <div class="card-content">
            <h3>ENTREGAS</h3>
            <div class="card-stats">
              <span class="stats-number">{{ deliveries_count || 0 }}</span>
              <span class="stats-label">Pendentes</span>
            </div>
          </div>
          <div class="card-arrow">
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </div>
        </div>
      </div>

      <div class="row" v-if="loaded">
        
        
        <!-- Seção de Compras por Mês -->
        <div class="dashboard-section">
          <h4 class="section-title">Compras por Mês</h4>
          <MonthPurchases 
            @setLastMonthAmount="setLastMonthAmount" 
            @setLastMonthValue="setLastMonthValue"
            @setPenultimateMonthValue="setPenultimateMonthValue"
            @setPenultimateMonthAmount="setPenultimateMonthAmount">
          </MonthPurchases>
        </div>

        <!-- Seção de Saldo Restante (dias) -->
        <div class="dashboard-section">
          <h4 class="section-title">Saldo restante (dias)</h4>
          <div class="balance-grid">
            <div v-for="(contract, index) in dataChart.deadline" 
                 :key="index" 
                
                 class="balance-card">
              <div class="balance-header">
                <div class="balance-info">
                  <h5 class="balance-title">Negociação Nº: {{ contract.label || 'N/A' }}</h5>
                  <p class="balance-subtitle">
                    Cliente: {{ (contract.label_cliente || "").trim() ? contract.label_cliente : "Não informado" }}
                  </p>
                </div>
                <div class="balance-dates">
                  <span class="date-range">{{ contract.ini || 'N/A' }} até {{ contract.fin || 'N/A' }}</span>
                  <span class="remaining-days">{{ contract.prazo_restante !== null && contract.prazo_restante !== undefined ? contract.prazo_restante : 'N/A' }} dia(s) restantes</span>
                </div>
              </div>
              <CustomProgress :value="contract.percentage || 0" />
            </div>
          </div>
          
          <div class="show-more-container" v-if="dataChart.deadline.length > 5">
            <button 
              @click="deadline_total_show = deadline_total_show === 5 ? 9999999 : 5" 
              class="btn btn-primary">
              {{ deadline_total_show === 5 ? 'Exibir todos' : 'Exibir menos' }}
            </button>
          </div>
        </div>

        <!-- Seção de Saldo Restante (quantidade) -->
        <div class="dashboard-section">
          <h4 class="section-title">Saldo restante (quantidade)</h4>
          <div class="balance-grid">
            <div v-for="(contract, index) in dataChart.quantity" 
                 :key="index"              
                 class="balance-card">
              <div class="balance-header">
                <div class="balance-info">
                  <h5 class="balance-title">Negociação Nº: {{ contract.label || 'N/A' }}</h5>
                  <p class="balance-subtitle">
                    Cliente: {{ (contract.label_cliente || "").trim() ? contract.label_cliente : "Não informado" }}
                  </p>
                </div>
                <div class="balance-amounts">
                  <div class="amount-item">
                    <span class="amount-label">Saldo total:</span>
                    <span class="amount-value">
                      {{ contract.prazo_total !== null && contract.prazo_total !== undefined ? new Intl.NumberFormat("pt-BR", {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }).format(contract.prazo_total) : 'N/A' }}
                      {{ contract.unity_measure || '' }}
                    </span>
                  </div>
                  <div class="amount-item">
                    <span class="amount-label">Saldo restante:</span>
                    <span class="amount-value">
                      {{ contract.prazo_restante !== null && contract.prazo_restante !== undefined ? new Intl.NumberFormat("pt-BR", {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }).format(contract.prazo_restante) : 'N/A' }}
                      {{ contract.unity_measure || '' }}
                    </span>
                  </div>
                </div>
              </div>
              <CustomProgress :value="contract.percentage || 0" />
            </div>
          </div>

          <div class="show-more-container" v-if="dataChart.quantity.length > 5">
            <button 
              @click="quantity_total_show = quantity_total_show === 5 ? 9999999 : 5" 
              class="btn btn-primary">
              {{ quantity_total_show === 5 ? 'Exibir todos' : 'Exibir menos' }}
            </button>
          </div>
        </div>

        <div class="dashboard-section">
          <gauges-dashboard :contracts="contracts"></gauges-dashboard>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-warning centered" role="alert">
            Não existe nenhum contrato/negociação ativo para este cliente/loja,
            procure o atendimento.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GaugesDashboard from "./GaugesDashboard.vue";
import MonthlyAmountOrders from "./Charts/MonthAmountOrders.vue";
import MonthPurchases from "./Charts/MonthPurchases.vue";
import Bar from "./Charts/Financial/Bar.vue";
import CustomProgress from "./CustomProgress.vue";

export default {
  components: {
    MonthlyAmountOrders,
    MonthPurchases,
    CustomProgress,
    GaugesDashboard,
    Bar,
  },
  data() {
    return {
      deadline_total_show: 5,
      quantity_total_show: 5,
      last_month_amount: 0,
      last_month_value: 0,
      penultimate_month_amount: 0,
      penultimate_month_value: 0,
    };
  },
  computed: {
    contracts() {
      return this.$store.getters.dashboardContracts;
    },
    dataChart() {
      return this.$store.getters.dashboardChartData;
    },
    deliveries_count() {
      return this.$store.getters.dashboardDeliveriesCount;
    },
    pending_invoices() {
      return this.$store.getters.dashboardPendingInvoices;
    },
    pending_invoices_total() {
      return this.$store.getters.dashboardPendingInvoicesTotal;
    },
    loaded() {
      return this.$store.getters.dashboardLoaded;
    },
    alert() {
      return this.$store.getters.dashboardAlert;
    },
    getLastMonthValueBR() {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(this.last_month_value);
    },
    lastMonthPercentAmmount() {
      const self = this;
      if (this.penultimate_month_amount === 0) {
        return "...";
      }
      setTimeout(function () {
        self.$store.dispatch("setLoadingChartAmount", true);
      }, 500);
      let percent =
        (this.last_month_amount / this.penultimate_month_amount) * 100;

      if (percent < 100) {
        return "-" + (100 - percent).toFixed(2) + "%";
      }
      return "+" + (percent - 100).toFixed(2) + "%";
    },
    lastMonthPercentValue() {
      if (this.penultimate_month_value === 0) {
        return "...";
      }
      let percent =
        (this.last_month_value / this.penultimate_month_value) * 100;

      if (percent < 100) {
        return "-" + (100 - percent).toFixed(2) + "%";
      }
      return "+" + (percent - 100).toFixed(2) + "%";
    },
  },
  methods: {
    setLastMonthAmount(value) {      
      this.last_month_amount = value;
    },
    setLastMonthValue(value) {
      this.last_month_value = value;
    },
    setPenultimateMonthAmount(value) {
      this.penultimate_month_amount = value;
    },
    setPenultimateMonthValue(value) {
      this.penultimate_month_value = value;
    },
    async initializeDashboard() {
      await this.$store.dispatch('initializeDashboard');
    },
    navigateToContratos() {
      this.$router.push('/admin/contract-list');
    },
    navigateToPedidos() {
      this.$router.push('/admin/order-list');
    },
    navigateToFinanceiro() {
      this.$router.push('/admin/invoice-list');
    },
    navigateToEntregas() {
      this.$router.push('/admin/order-finished-list');
    }
  },
  beforeUnmount() {
    this.$store.dispatch("setLoadingChartAmount", false);
  },
  mounted() {
    if (
      this.$store.state.user.type_id != 1 &&
      this.$store.state.maintenance == true
    ) {
      // Em manutenção
    } else {
      this.initializeDashboard();
    }
  },
};
</script>



<style scoped>

.bg-success {
  background-color: #68cf29 !important;
}
.dashboard-container {
  /* padding: 1.5rem; */
  background: #f8f9fa;
  border-radius: 1rem;
}

.dashboard-content {
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.highlight-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.highlight-card {
  background: white;
  border-radius: 1rem;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  min-height: 80px;
}

.highlight-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  transition: all 0.3s ease;
}

.highlight-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

.highlight-card.contracts::before { background-color: #4CAF50; }
.highlight-card.orders::before { background-color: #2196F3; }
.highlight-card.financial::before { background-color: #F44336; }
.highlight-card.deliveries::before { background-color: #FF9800; }

.card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.contracts .card-icon { background-color: #E8F5E9; color: #4CAF50; }
.orders .card-icon { background-color: #E3F2FD; color: #2196F3; }
.financial .card-icon { background-color: #FFEBEE; color: #F44336; }
.deliveries .card-icon { background-color: #FFF3E0; color: #FF9800; }

.card-content {
  flex: 1;
}

.card-content h3 {
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748B;
  margin: 0 0 0.25rem 0;
  letter-spacing: 0.5px;
}

.card-stats {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stats-number {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1E293B;
}

.stats-label {
  font-size: 0.875rem;
  color: #64748B;
}

.trend-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.25rem;
  width: fit-content;
}

.trend-badge.positive {
  background-color: #E8F5E9;
  color: #2E7D32;
}

.trend-badge:not(.positive) {
  background-color: #FFEBEE;
  color: #C62828;
}

.card-arrow {
  color: #94A3B8;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
}

.highlight-card:hover .card-arrow {
  opacity: 1;
  transform: translateX(0);
}

.section-title {
  font-size: 1.25rem;
  color: #2c3e50;
  text-align: center;
  margin: 1rem 0 1rem;
  font-weight: 600;
}

.balance-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.balance-card {
  background: white;
  border-radius: 0.75rem;
  padding: 1rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.balance-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.balance-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.balance-info {
  flex: 1 1 60%;
  margin-right: 0.5rem;
}

.balance-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #34495e;
  margin-bottom: 0.25rem;
}

.balance-subtitle {
  color: #7f8c8d;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
}

.balance-dates, .balance-amounts {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: right;
  flex: 1 1 35%;
}

.date-range, .remaining-days {
  font-size: 0.8rem;
  color: #7f8c8d;
}

.amount-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.amount-label {
  font-size: 0.7rem;
  color: #95a5a6;
  text-transform: uppercase;
}

.amount-value {
  font-weight: 600;
  color: #34495e;
  font-size: 0.85rem;
}

.show-more-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.alert-container {
  padding: 2rem;
}

.alert {
  display: flex;
  align-items: center;
  gap: 1rem;
}

@media (max-width: 768px) {
  .highlight-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  .balance-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .highlight-cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>